import routes from '@/shared/constant/routes';

// ALL Roles
export const roles = {
  OWNER: 4,
  SUPER_ADMIN: 1,
  FINANCIAL_MANAGER: 12,
  SUPERVISOR: 5,
  ONBOARDING: 6,
  ONBOARDING_SUPERVISOR: 7,
  INVENTORY_SPECIALIST: 13,
  FACTORY_SUPERVISOR: 14,
  PRINTHOUSE_SPECIALIST: 15,
  COMPANY_ADMIN: 16,
  PRODUCTION_MANAGER: 17,
} as const;
// Temp commit
// All Permissions
export const permissions = {
  // pages
  CAN_VIEW_CREATE_COMPANY: 'CAN_VIEW_CREATE_COMPANY',
  CAN_VIEW_HOME_PAGE: 'CAN_VIEW_HOME_PAGE',
  CAN_VIEW_WORKING_DAY: 'CAN_VIEW_WORKING_DAY',
  CAN_VIEW_SUPPLIERS: 'CAN_VIEW_SUPPLIERS',
  CAN_VIEW_WORKERS_TIMESHEET: 'CAN_VIEW_WORKERS_TIMESHEET',
  CAN_VIEW_WORKFORCE: 'CAN_VIEW_WORKFORCE',
  CAN_VIEW_CONTRACTS: 'CAN_VIEW_CONTRACTS',
  CAN_ADD_CONTRACTS: 'CAN_ADD_CONTRACTS',
  CAN_VIEW_STATISTICS: 'CAN_VIEW_STATISTICS',
  CAN_VIEW_SUBSCRIPTION: 'CAN_VIEW_SUBSCRIPTION',
  CAN_VIEW_BILLING: 'CAN_VIEW_BILLING',
  CAN_VIEW_ONBOARDING: 'CAN_VIEW_ONBOARDING',

  CAN_VIEW_PRINTING_ORDERS: 'CAN_VIEW_PRINTING_ORDERS',

  CAN_VIEW_WORKING_DAY_RECONCILIATION: 'CAN_VIEW_WORKING_DAY_RECONCILIATION',
  CAN_VIEW_PERIODIC_OPERATIONS: 'CAN_VIEW_PERIODIC_OPERATIONS',
  CAN_VIEW_WAREHOUSES: 'CAN_VIEW_WAREHOUSES',
  CAN_VIEW_ADD_NEW_STOCK: 'CAN_VIEW_ADD_NEW_STOCK',

  CAN_VIEW_DISPATCH_REQUESTS: 'CAN_VIEW_DISPATCH_REQUESTS',
  CAN_VIEW_DISPATCH_REQUEST_DETAILS: 'CAN_VIEW_DISPATCH_REQUEST_DETAILS',

  CAN_ADD_CREW: 'CAN_ADD_CREW',

  // general
  PUBLIC_PERMISSIONS: 'PUBLIC_PERMISSIONS',
  NOT_AUTHORIZED: 'NOT_AUTHORIZED',
  // custome permissions
  CAN_LOGIN: 'CAN_LOGIN',

  // HOME
  CAN_VIEW_INSIGHTS: 'CAN_VIEW_INSIGHTS',
  CAN_CHANGE_ASSET: 'CAN_CHANGE_ASSET',
  CAN_CHANGE_DATE: 'CAN_CHANGE_DATE',

  // Warehouse
  CAN_ADD_WAREHOUSE: 'CAN_ADD_WAREHOUSE',
  CAN_ADD_TEAM_MEMBER_TO_WAREHOUSE: 'CAN_ADD_TEAM_MEMBER_TO_WAREHOUSE',

  // WORKING DAY
  CAN_VIEW_INSTANCE_DETAILS: 'CAN_VIEW_INSTANCE_DETAILS',
  CAN_EDIT_INSTANCE_PRODUCTIVITY: 'EDIT_INSTANCE_PRODUCTIVITY',
  CAN_END_INSTANCE: 'CAN_END_INSTANCE',
  CAN_APPROVE_INSTANCE: 'CAN_APPROVE_INSTANCE',
  CAN_ADD_TECHNICAL_OPERATION: 'CAN_ADD_TECHNICAL_OPERATION',

  // SETTLEMENT=>Financial Reconciliations
  CAN_VIEW_DEDUCTION_DETAILS: 'CAN_VIEW_DEDUCTION_DETAILS',
  CAN_ADD_DEDUCTION: 'CAN_ADD_DEDUCTION',
  CAN_EDIT_DEDUCTION: 'CAN_EDIT_DEDUCTION',
  CAN_DELETE_DEDUCTION: 'CAN_DELETE_DEDUCTION',
  CAN_VIEW_BONUSES_DETAILS: 'CAN_VIEW_BONUSES_DETAILS',
  CAN_ADD_BONUS: 'CAN_ADD_BONUS',
  CAN_DELETE_BONUS: 'CAN_DELETE_BONUS',
  CAN_EDIT_BONUS: 'CAN_EDIT_BONUS',

  // SETTLEMENT=> Settlements Pages
  CAN_VIEW_SETTLEMENTS: 'CAN_VIEW_SETTLEMENTS',

  // SETTLEMENT=>Agreement Details
  CAN_VIEW_AGREEMENT_DETAILS: 'CAN_VIEW_AGREEMENT_DETAILS',
  CAN_EDIT_AGREEMENT_DETAILS: 'CAN_EDIT_AGREEMENT_DETAILS',

  // SUPPLIER
  CAN_ADD_SUPPLIER: 'CAN_ADD_SUPPLIER',
  CAN_EDIT_SUPPLIER: 'CAN_EDIT_SUPPLIER',
  CAN_DELETE_SUPPLIER: 'CAN_DELETE_SUPPLIER',

  // WORKERS
  CAN_ADD_WORKER: 'CAN_EDIT_WORKER',
  CAN_DELETE_WORKER: 'CAN_DELETE_WORKER',
  CAN_EDIT_WORKER: 'CAN_EDIT_WORKER',

  // USER MANAGEMENT
  CAN_ADD_USER: 'CAN_ADD_USER',
  CAN_DELETE_USER: 'CAN_DELETE_USER',
  CAN_EDIT_USER: 'CAN_EDIT_USER',

  // Fields Management
  CAN_ADD_FIELD: 'CAN_ADD_FIELD',
  CAN_ADD_FIELD_IN_TECHNICAL_OPERATION: 'CAN_ADD_FIELD_IN_TECHNICAL_OPERATION',
  CAN_ADD_FIELD_WITH_EMPTY_PROPERTY: 'CAN_ADD_FIELD_WITH_EMPTY_PROPERTY',

  // Crops Management
  CAN_ASSIGN_NEW_CROP: 'CAN_ASSIGN_NEW_CROP',
  CAN_UNASSIGN_CROP: 'CAN_UNASSIGN_CROP',
  CAN_ASSIGN_JOB_TO_CROP: 'CAN_ASSIGN_JOB_TO_CROP',
  CAN_UNASSIGN_JOB_TO_CROP: 'CAN_UNASSIGN_JOB_TO_CROP',

  // Settings
  CAN_VIEW_SETTINGS: 'CAN_VIEW_SETTINGS',
  CAN_ADD_MEASUREMENT_UNITS: 'CAN_ADD_MEASUREMENT_UNITS',
  CAN_CONFIQURE_ID: 'CAN_CONFIQURE_ID',

  // Periodic Operations
  CAN_ADD_PERIODIC_OPERATIONS: 'CAN_ADD_PERIODIC_OPERATIONS',

  // Custom Operations
  CAN_ADD_CUSTOM_OPERATIONS: 'CAN_ADD_CUSTOM_OPERATIONS',
};

// assign roles to permissions
export const rolesPermission: Record<string, number[]> = {
  // pages
  [permissions.CAN_VIEW_CREATE_COMPANY]: [
    roles.COMPANY_ADMIN,
    roles.SUPER_ADMIN,
  ],
  [permissions.CAN_VIEW_HOME_PAGE]: [
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.SUPER_ADMIN,
    roles.FINANCIAL_MANAGER,
    roles.PRODUCTION_MANAGER,
  ],
  [permissions.CAN_VIEW_WORKING_DAY]: [
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.SUPER_ADMIN,
    roles.FINANCIAL_MANAGER,
    roles.PRODUCTION_MANAGER,
  ],
  [permissions.CAN_VIEW_SUPPLIERS]: [
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.SUPER_ADMIN,
    roles.FINANCIAL_MANAGER,
  ],
  [permissions.CAN_VIEW_WORKERS_TIMESHEET]: [
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.SUPER_ADMIN,
    roles.FINANCIAL_MANAGER,
  ],
  [permissions.CAN_VIEW_WORKFORCE]: [
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.SUPER_ADMIN,
    roles.FINANCIAL_MANAGER,
  ],
  [permissions.CAN_VIEW_CONTRACTS]: [
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.SUPER_ADMIN,
    roles.FINANCIAL_MANAGER,
  ],
  [permissions.CAN_ADD_CONTRACTS]: [
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.SUPER_ADMIN,
    roles.FINANCIAL_MANAGER,
  ],

  // CREWS
  [permissions.CAN_ADD_CREW]: [
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.SUPER_ADMIN,
    roles.FINANCIAL_MANAGER,
  ],

  // PACKHOUSE
  [permissions.CAN_VIEW_PRINTING_ORDERS]: [
    // roles.OWNER,roles.COMPANY_ADMIN,
    // roles.SUPER_ADMIN,

    roles.PRINTHOUSE_SPECIALIST,
  ],

  [permissions.CAN_VIEW_WORKING_DAY_RECONCILIATION]: [
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.SUPER_ADMIN,
    roles.FINANCIAL_MANAGER,
  ],
  [permissions.CAN_VIEW_STATISTICS]: [
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.PRODUCTION_MANAGER,
    roles.FINANCIAL_MANAGER,
  ],
  // ****************************************************************************************************
  // BILLING
  [permissions.CAN_VIEW_SUBSCRIPTION]: [roles.COMPANY_ADMIN],
  [permissions.CAN_VIEW_BILLING]: [roles.COMPANY_ADMIN],

  // ONBOARDING
  [permissions.CAN_VIEW_ONBOARDING]: [
    roles.COMPANY_ADMIN,
    roles.FINANCIAL_MANAGER,
    roles.INVENTORY_SPECIALIST,
    roles.ONBOARDING,
    roles.ONBOARDING_SUPERVISOR,
    roles.OWNER,
    roles.PRINTHOUSE_SPECIALIST,
    roles.PRODUCTION_MANAGER,
    roles.SUPERVISOR,
    roles.SUPER_ADMIN,
  ],
  // HOME
  [permissions.CAN_VIEW_INSIGHTS]: [
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.SUPER_ADMIN,
    roles.FINANCIAL_MANAGER,
  ],
  [permissions.CAN_CHANGE_ASSET]: [
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.SUPER_ADMIN,
    roles.FINANCIAL_MANAGER,
  ],
  [permissions.CAN_CHANGE_DATE]: [roles.SUPER_ADMIN],
  // WORKING DAY
  [permissions.CAN_VIEW_INSTANCE_DETAILS]: [
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.SUPER_ADMIN,
    roles.FINANCIAL_MANAGER,
  ],
  [permissions.CAN_ADD_TECHNICAL_OPERATION]: [
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.SUPER_ADMIN,
    roles.PRODUCTION_MANAGER,
  ],
  [permissions.CAN_EDIT_INSTANCE_PRODUCTIVITY]: [
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.SUPER_ADMIN,
  ],

  [permissions.CAN_END_INSTANCE]: [
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.SUPER_ADMIN,
  ],
  [permissions.CAN_APPROVE_INSTANCE]: [
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.SUPER_ADMIN,
  ],

  // SETTLEMENT=>Financial Reconciliations
  [permissions.CAN_VIEW_DEDUCTION_DETAILS]: [
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.SUPER_ADMIN,
    roles.FINANCIAL_MANAGER,
  ],
  [permissions.CAN_ADD_DEDUCTION]: [
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.SUPER_ADMIN,
    roles.FINANCIAL_MANAGER,
  ],
  [permissions.CAN_EDIT_DEDUCTION]: [
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.SUPER_ADMIN,
    roles.FINANCIAL_MANAGER,
  ],
  [permissions.CAN_DELETE_DEDUCTION]: [
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.SUPER_ADMIN,
    roles.FINANCIAL_MANAGER,
  ],
  [permissions.CAN_VIEW_BONUSES_DETAILS]: [
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.SUPER_ADMIN,
    roles.FINANCIAL_MANAGER,
  ],
  [permissions.CAN_ADD_BONUS]: [
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.SUPER_ADMIN,
    roles.FINANCIAL_MANAGER,
  ],
  [permissions.CAN_DELETE_BONUS]: [
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.SUPER_ADMIN,
    roles.FINANCIAL_MANAGER,
  ],
  [permissions.CAN_EDIT_BONUS]: [
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.SUPER_ADMIN,
    roles.FINANCIAL_MANAGER,
  ],

  // Settlements
  [permissions.CAN_VIEW_SETTLEMENTS]: [
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.SUPER_ADMIN,
    roles.FINANCIAL_MANAGER,
  ],

  // Agreement Details
  [permissions.CAN_VIEW_AGREEMENT_DETAILS]: [
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.SUPER_ADMIN,
    roles.FINANCIAL_MANAGER,
  ],
  [permissions.CAN_EDIT_AGREEMENT_DETAILS]: [
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.SUPER_ADMIN,
    roles.FINANCIAL_MANAGER,
  ],

  // SUPPLIER
  [permissions.CAN_ADD_SUPPLIER]: [
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.SUPER_ADMIN,
  ],
  [permissions.CAN_EDIT_SUPPLIER]: [
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.SUPER_ADMIN,
  ],
  [permissions.CAN_DELETE_SUPPLIER]: [
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.SUPER_ADMIN,
  ],

  // WORKERS
  [permissions.CAN_ADD_WORKER]: [
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.SUPER_ADMIN,
  ],
  [permissions.CAN_DELETE_WORKER]: [
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.SUPER_ADMIN,
  ],
  [permissions.CAN_EDIT_WORKER]: [
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.SUPER_ADMIN,
  ],

  // USER MANAGEMENT
  [permissions.CAN_ADD_USER]: [
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.SUPER_ADMIN,
  ],
  [permissions.CAN_DELETE_USER]: [
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.SUPER_ADMIN,
  ],
  [permissions.CAN_EDIT_USER]: [
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.SUPER_ADMIN,
  ],

  // Fields Management
  [permissions.CAN_ADD_FIELD]: [
    roles.COMPANY_ADMIN,
    roles.ONBOARDING,
    roles.ONBOARDING_SUPERVISOR,
    roles.OWNER,
    roles.PRINTHOUSE_SPECIALIST,
    roles.SUPERVISOR,
    roles.SUPER_ADMIN,
  ],

  [permissions.CAN_ADD_FIELD_IN_TECHNICAL_OPERATION]: [
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.SUPER_ADMIN,
  ],

  [permissions.CAN_ADD_FIELD_WITH_EMPTY_PROPERTY]: [
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.SUPER_ADMIN,
  ],

  // Crops Management
  [permissions.CAN_ASSIGN_NEW_CROP]: [
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.SUPER_ADMIN,
  ],
  [permissions.CAN_UNASSIGN_CROP]: [
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.SUPER_ADMIN,
  ],
  [permissions.CAN_ASSIGN_JOB_TO_CROP]: [
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.SUPER_ADMIN,
  ],
  [permissions.CAN_UNASSIGN_JOB_TO_CROP]: [
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.SUPER_ADMIN,
  ],

  // Settings
  [permissions.CAN_ADD_MEASUREMENT_UNITS]: [
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.SUPER_ADMIN,
  ],
  [permissions.CAN_CONFIQURE_ID]: [
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.SUPER_ADMIN,
  ],
  [permissions.CAN_VIEW_SETTINGS]: [
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.SUPER_ADMIN,
  ],

  // Warehouses
  // TODO: update users types
  [permissions.CAN_VIEW_WAREHOUSES]: [
    roles.SUPER_ADMIN,
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.INVENTORY_SPECIALIST,
  ],
  [permissions.CAN_VIEW_ADD_NEW_STOCK]: [
    roles.SUPER_ADMIN,
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.INVENTORY_SPECIALIST,
  ],
  [permissions.CAN_ADD_WAREHOUSE]: [
    roles.SUPER_ADMIN,
    roles.OWNER,
    roles.COMPANY_ADMIN,
  ],
  [permissions.CAN_ADD_TEAM_MEMBER_TO_WAREHOUSE]: [
    roles.SUPER_ADMIN,
    roles.OWNER,
    roles.COMPANY_ADMIN,
  ],

  // Dispatch Requests
  // TODO: update permissions
  [permissions.CAN_VIEW_DISPATCH_REQUESTS]: [
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.SUPER_ADMIN,
    roles.INVENTORY_SPECIALIST,
  ],
  [permissions.CAN_VIEW_DISPATCH_REQUEST_DETAILS]: [
    roles.SUPER_ADMIN,
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.INVENTORY_SPECIALIST,
  ],

  // Periodic Operations
  [permissions.CAN_VIEW_PERIODIC_OPERATIONS]: [
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.PRODUCTION_MANAGER,
    roles.FINANCIAL_MANAGER,
    roles.SUPER_ADMIN,
  ],
  [permissions.CAN_ADD_PERIODIC_OPERATIONS]: [
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.SUPER_ADMIN,
    roles.PRODUCTION_MANAGER,
  ],

  // Custom Operations
  [permissions.CAN_ADD_CUSTOM_OPERATIONS]: [
    roles.OWNER,
    roles.COMPANY_ADMIN,
    roles.SUPER_ADMIN,
  ],

  // COMPANY
  // [permissions.CAN_ADD_COMPANY]: [roles.OWNER],
};

// after login redirect to x depend on user role
// TODO: redirect to onboarding depending on if list is not done
export const REDIRECT_AFTER_LOGIN = {
  [roles.OWNER]: routes.home,
  [roles.COMPANY_ADMIN]: routes.home,
  [roles.SUPER_ADMIN]: routes.home,
  [roles.FINANCIAL_MANAGER]: routes.home,
  [roles.SUPERVISOR]: routes.home,
  [roles.FACTORY_SUPERVISOR]: routes.home,
  [roles.ONBOARDING]: routes.home,
  [roles.ONBOARDING_SUPERVISOR]: routes.home,
  [roles.PRODUCTION_MANAGER]: routes.home,
  [roles.INVENTORY_SPECIALIST]: routes.warehouses,
  [roles.PRINTHOUSE_SPECIALIST]: routes.printingOrders,

  default: routes.home,
};
